import { useEffect, useState } from 'react'
import MuiBox from '@mui/material/Box'
import MuiIconButton from '@mui/material/IconButton'
import MuiTypography from '@mui/material/Typography'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'

import ProducerList from './components/producerList'
import ProducerDrawer from './components/producerDrawer'

const Producers = ({ client }) => {
  const [showDrawer, setShowDrawer] = useState(false)
  const [producer, setProducer] = useState()

  useEffect(() => {
    if (!showDrawer) setProducer()
  }, [showDrawer])

  return (
    <>
      <ProducerDrawer producer={producer} client={client} showDrawer={showDrawer} setShowDrawer={setShowDrawer} />
      <MuiBox sx={{ display: 'flex', alignItems: 'center' }}>
        <MuiTypography variant="h6">PRODUCERS</MuiTypography>
        {client?.id && (
          <MuiIconButton onClick={() => setShowDrawer(true)}>
            <AddCircleOutlineIcon />
          </MuiIconButton>
        )}
      </MuiBox>
      {!client?.id && <MuiTypography>You will be able to add producers after you save this Client.</MuiTypography>}
      {client?.producers?.length > 0 && (
        <ProducerList
          client={client}
          producer={producer}
          setProducer={setProducer}
          showDrawer={showDrawer}
          setShowDrawer={setShowDrawer}
        />
      )}
      {client?.id && !client?.producers?.length && (
        <MuiTypography>No producers have been added for this client.</MuiTypography>
      )}
    </>
  )
}

export default Producers
